import "babel-polyfill";
import "slick-carousel";
import YouTubePlayer from "youtube-player";
import "./libs/jquery.scrollify";
import Isotope from "isotope-layout";
import "isotope-packery";

import binder from "./libs/binder";
import {constants, dropdown, accordion, mainClass, formStates} from "./modules/module";
import {headerNavigation, burgerTrigger} from "./modules/header";
import {ytplayer} from "./modules/player";
import {slider} from "./modules/slider&isotop";
import {scrollAnimation, introSection} from "./modules/scrollAnimations";
import {banner} from "./modules/banner";


binder({
    bounds: {
        "html": [constants, mainClass],
        ".js-drop": dropdown,
        ".js-accordion": accordion,
        ".js-header": [headerNavigation, burgerTrigger],
        ".js-video": ytplayer(YouTubePlayer),
        ".js-slider": slider(Isotope),
        ".js-scroll-section": introSection,
        ".js-animate": scrollAnimation,
        ".contacts-block": formStates,
        ".banner": banner
    },
    runTests: true
});



// WEBPACK FOOTER //
// ./assets/js/global.js